var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7124 8.71017C14.2115 8.67817 13.594 8.67817 12.7999 8.67817H5.9999C5.20579 8.67817 4.58826 8.67817 4.0874 8.71017M14.7124 8.71017C15.3375 8.75006 15.781 8.83984 16.1595 9.0415C16.7593 9.36106 17.2469 9.87095 17.5525 10.4982C17.8999 11.2113 17.8999 12.1446 17.8999 14.0115V15.5671C17.8999 17.4339 17.8999 18.3673 17.5525 19.0804C17.2469 19.7076 16.7593 20.2175 16.1595 20.5371C15.4777 20.9004 14.5851 20.9004 12.7999 20.9004H5.9999C4.21469 20.9004 3.32219 20.9004 2.64028 20.5371C2.0405 20.2175 1.55291 19.7076 1.24734 19.0804C0.899902 18.3673 0.899902 17.4339 0.899902 15.5671V14.0115C0.899902 12.1446 0.899902 11.2113 1.24734 10.4982C1.55291 9.87095 2.0405 9.36106 2.64028 9.0415C3.01885 8.83984 3.46233 8.75006 4.0874 8.71017M14.7124 8.71017V6.45595C14.7124 3.3877 12.3339 0.900391 9.3999 0.900391C6.46591 0.900391 4.0874 3.3877 4.0874 6.45595V8.71017",
    stroke: "#104145",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.ca4ab94c5a79a241cd02718a3fba7acc.svg";
export { ForwardRef as ReactComponent };